module.exports = __webpack_public_path__ + "img/tablet-pizzaria.6e2f07b0.png";